export enum SUB_SECTION_PROGRESS_STATE {
  NONE = 'NONE',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
}
